if (!customElements.get('ugc-carousel')) {
  class UgcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ugc-track');
      this.section = this.closest('[id^="UgcCarousel-"]');
      this.prevBtn = this.section.querySelector('[data-ugc-prev]');
      this.nextBtn = this.section.querySelector('[data-ugc-next]');
      this.progressDot = this.section.querySelector('[data-ugc-progress]');
      this.progressTrack = this.section.querySelector('.ugc-progress-track');
      this.cards = Array.from(this.querySelectorAll('[data-ugc-card]'));

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateProgress(), { passive: true });

      this.cards.forEach((card) => {
        const playBtn = card.querySelector('[data-ugc-play]');
        if (!playBtn) return;
        card.addEventListener('click', () => this.playCard(card));
      });

      this.updateProgress();
      window.addEventListener('resize', () => this.updateProgress());
    }

    scrollByCard(direction) {
      const card = this.cards[0];
      if (!card) return;
      const cardWidth = card.getBoundingClientRect().width + 12;
      this.track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
    }

    updateProgress() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const ratio = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;
      const trackWidth = this.progressTrack ? this.progressTrack.clientWidth : 0;
      if (this.progressDot) {
        this.progressDot.style.left = (ratio * (trackWidth - 8)) + 'px';
      }
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
      if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 2;
    }

    playCard(card) {
      const holder = card.querySelector('[data-ugc-video-holder]');
      if (!holder) return;
      this.cards.forEach((other) => {
        if (other === card) return;
        other.classList.remove('is-playing');
        const video = other.querySelector('video');
        if (video) video.pause();
      });
      holder.hidden = false;
      card.classList.add('is-playing');
      const video = holder.querySelector('video');
      if (video) {
        video.play().catch(() => {});
      }
    }
  }

  customElements.define('ugc-carousel', UgcCarousel);
}
